import {
  NavItem,
  PlatformKeys,
  SocialKeys,
  Socials,
} from "@kelp-dao/kernel-design-system";
import {
  BookIcon,
  GavelIcon,
  GithubLogoIcon,
  GraphIcon,
  NewspaperIcon,
  PaintBrushIcon,
  ScrollIcon,
  VaultIcon,
} from "@phosphor-icons/react";

import { trackEvent } from "utils";
import { FAVICONS, ICONS } from "../../public/assetsV2/images";

export const useGainNavItems = (): NavItem[] => {
  return [
    {
      label: "Products",
      skipLabelInMobile: true,
      skipInDesktop: true,
      submenu: [
        {
          label: "Kelp",
          description: "Restaked ETH. Routed across 10+ L2s.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kelp`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kelp.src}
              alt="Kelp"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kelp",
            });
          },
        },
        {
          label: "Gain",
          description:
            "No lockups. No thresholds. Just vaults that don't sleep.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kelp/gain`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Gain.src}
              alt="Gain"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Gain",
            });
          },
        },
        {
          label: "Kernel",
          description: "Restake BNB, BTC & more. Secure 25+ protocols.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kernel`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kernel.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kernel",
            });
          },
        },
      ],
    },

    {
      label: "Governance",
      submenu: [
        {
          icon: (
            <img
              src={ICONS.KernelStakeIcon.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Stake $KERNEL",
          description: "Participate in KernelDAO Governance",
          href: "https://kerneldao.com/stake/",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Stake $KERNEL",
              destination_url: "https://kerneldao.com/stake/",
            });
          },
        },
        {
          icon: (
            <ScrollIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Forum",
          description: "Discuss & debate on proposals",
          href: "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Forum",
              destination_url:
                "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
            });
          },
        },
        {
          icon: (
            <GavelIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Vote",
          description: "Use your voting power to shape KERNELDAO",
          href: "https://snapshot.box/#/s:kernelgov.eth",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Vote",
              destination_url: "https://snapshot.box/#/s:kernelgov.eth",
            });
          },
        },
      ],
      submenuLayout: "double",
    },
    {
      label: "Blogs",
      href: "https://blogs.kerneldao.com/",
      description: "Read our latest news and updates.",
      icon: (
        <NewspaperIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      sendEvent: () => {
        trackEvent("lp_header_nav_click", {
          event_type: "button_click",
          event_category: "Landing",
          category: "Blogs",
          label: "Blogs",
          destination_url: "https://blogs.kerneldao.com/",
        });
      },
    },
    {
      label: "Ecosystem",
      href: "https://kerneldao.com/ecosystem/",
      description: "Explore our ecosystem and community.",
      icon: (
        <GraphIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      sendEvent: () => {
        trackEvent("lp_header_nav_click", {
          event_type: "button_click",
          event_category: "Landing",
          category: "Ecosystem",
          label: "Ecosystem",
          destination_url: "https://kerneldao.com/ecosystem/",
        });
      },
    },
    {
      label: "More",
      skipLabelInMobile: true,
      submenuLayout: "double",
      submenu: [
        {
          label: "Litepaper",
          description: "Read our approach to restaking.",
          icon: (
            <ScrollIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Insights",
          href: "https://kerneldao.gitbook.io/litepaper",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Litepaper",
              destination_url: "https://kerneldao.gitbook.io/litepaper",
            });
          },
        },
        {
          label: "Docs",
          description: "Technical documentation and guides.",
          icon: (
            <BookIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Insights",
          href: "https://kerneldao.gitbook.io/kernel",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Docs",
              destination_url: "https://kerneldao.gitbook.io/kernel",
            });
          },
        },
        {
          label: "Brandkit",
          description: "Logos and everything you need.",
          icon: (
            <PaintBrushIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Developers",
          href: "https://kerneldao.com/brand-kit/",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Brandkit",
              destination_url: "https://kerneldao.com/brand-kit/",
            });
          },
        },
        {
          label: "Github",
          description: "Explore our open-source code.",
          icon: (
            <GithubLogoIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Developers",
          href: "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Github",
              destination_url:
                "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
            });
          },
        },
      ],
      submenuFooter: (
        <Socials
          platformIconWidth={12}
          platformIconHeight={12}
          size={24}
          socials={[
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/kernel_dao",
              platformKey: PlatformKeys.KERNEL,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/kernel_dao",
                });
              },
            },
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/KelpDAO",
              platformKey: PlatformKeys.KELP,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/KelpDAO",
                });
              },
            },
            {
              key: SocialKeys.DISCORD,
              link: "https://discord.gg/khSpqCFvGq",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "discord",
                  location: "header",
                  destination_url: "https://discord.gg/khSpqCFvGq",
                });
              },
            },
            {
              key: SocialKeys.TELEGRAM,
              link: "https://t.me/KelpDAOxyz/",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "telegram",
                  location: "header",
                  destination_url: "https://t.me/KelpDAOxyz/",
                });
              },
            },
          ]}
        />
      ),
    },
  ];
};

export const useGainAppNavItems = (): NavItem[] => {
  return [
    {
      label: "Products",
      skipLabelInMobile: true,
      skipInDesktop: true,
      submenu: [
        {
          label: "Kelp",
          description: "Restaked ETH. Routed across 10+ L2s.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kelp`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kelp.src}
              alt="Kelp"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kelp",
              location: "header",
            });
          },
        },
        // {
        //   label: "Gain",
        //   description:
        //     "No lockups. No thresholds. Just vaults that don't sleep.",
        //   skipDescriptionInMobile: true,
        //   href: `https://kerneldao.com/gain`,
        //   external: true,
        //   icon: (
        //     <img
        //       src={FAVICONS.Gain.src}
        //       alt="Gain"
        //       className="w-4 h-4 lg:w-6 lg:h-6"
        //     />
        //   ),
        //   sendEvent: () => {
        //     trackEvent("lp_product_selected", {
        //       event_type: "button_click",
        //       event_category: "Landing",
        //       event_label: "Gain",
        //       location: "header",
        //     });
        //   },
        // },
        {
          label: "Kernel",
          description: "Restake BNB, BTC & more. Secure 25+ protocols.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kernel`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kernel.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kernel",
              location: "header",
            });
          },
        },
      ],
    },
    {
      label: "All Vaults",
      description:
        "Deposit to vaults to earn the highest yield on your assets.",
      skipInDesktop: true,
      href: "/gain",
      icon: (
        <VaultIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      submenuFooter: (
        <Socials
          platformIconWidth={12}
          platformIconHeight={12}
          size={24}
          socials={[
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/kernel_dao",
              platformKey: PlatformKeys.KERNEL,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/kernel_dao",
                });
              },
            },
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/KelpDAO",
              platformKey: PlatformKeys.KELP,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/KelpDAO",
                });
              },
            },
            {
              key: SocialKeys.DISCORD,
              link: "https://discord.gg/khSpqCFvGq",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "discord",
                  location: "header",
                  destination_url: "https://discord.gg/khSpqCFvGq",
                });
              },
            },
            {
              key: SocialKeys.TELEGRAM,
              link: "https://t.me/KelpDAOxyz/",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "telegram",
                  location: "header",
                  destination_url: "https://t.me/KelpDAOxyz/",
                });
              },
            },
          ]}
        />
      ),
    },
  ];
};
